import React from 'react';
import { Table } from 'react-bootstrap';
import ScreenHeader from '../components/ScreenHeader';
import Display from '../components/Display';
import useSWR from 'swr';
import { localAxios } from '../api';


function Success() {

  const { data, error, isLoading } = useSWR('/api/me', localAxios) 

  return (
    <div style={{ textAlign: 'center'}}>
        <Table align='center' striped bordered hover cellPadding={5}>
          <tbody>
            <tr>
              <td />
                <td style={{maxWidth: 850}}>
                <ScreenHeader message={"Visitor Training Tracker"}/>
                </td>
              <td />
            </tr>
          </tbody>
        </Table>
        <Table align='center' striped bordered hover cellPadding={5}>
          <tbody>
            <tr>
              <td />
              <td style={{maxWidth: 850}}>
                <br/>
                <br/>
                  <Display message={`Thank you for submitting your acknowledgment! The submission has been recorded.`}/>
                <br/>
                  After this visit, you will have 
                  <b>
                    {` ${5 - (data.data.visit_count)}`}
                  </b> more <b>{`${(5 - data.data.visit_count) > 1 ? "visits " : "visit "}`}</b> 
                  remaining before further training or certification is required.
                <br/>
                <br/>
                  You may now close this browser page.
              </td>
              <td />
            </tr>
          </tbody>
        </Table>
        <br/><br/>
        
      <br/>
      <br/>
        {/*message={`Submit`}*/}
    </div>
  );
}

export default Success;

